/**
 * Base API client for REST API requests
 */
class BaseAPI {
  constructor(baseUrl, nonce = null, defaultMethod = 'GET') {
    // Use window.azdsSiteUrl as the base URL for all API requests
    if (typeof window !== 'undefined' && window.azdsSiteUrl) {
      // Remove trailing slash from site URL if present
      const siteUrl = window.azdsSiteUrl.replace(/\/$/, '');

      if (baseUrl && baseUrl.startsWith('/')) {
        // If baseUrl starts with /, append it to site URL
        this.baseUrl = `${siteUrl}${baseUrl}`;
      } else if (baseUrl) {
        // If baseUrl is provided but doesn't start with /, add it with /
        this.baseUrl = `${siteUrl}/${baseUrl.replace(/^\//, '')}`;
      } else {
        // If baseUrl is empty, use site URL directly
        this.baseUrl = siteUrl;
      }
    } else {
      // Fallback to baseUrl if window.azdsSiteUrl is not available
      this.baseUrl = baseUrl || '';
    }
    this.nonce = nonce;
    this.defaultMethod = defaultMethod;
  }

  /**
   * Base method for making requests
   */
  async request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;

    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    };

    // Add X-WP-Nonce header if nonce is available
    if (this.nonce) {
      headers['X-WP-Nonce'] = this.nonce;
    }

    const config = {
      method: options.method || this.defaultMethod,
      headers,
      credentials: 'include',
      ...options,
    };

    try {
      const response = await fetch(url, config);

      let data;
      try {
        const text = await response.text();
        data = text ? JSON.parse(text) : {};
      } catch (jsonError) {
        throw new Error('Invalid JSON response');
      }

      return { response, data };
    } catch (error) {
      // Handle network errors
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        throw new Error('Network error. Please check your connection.');
      }
      // Preserve original error message
      throw error instanceof Error ? error : new Error('Connection error');
    }
  }
}

export default BaseAPI;
